import { useEffect, useRef, useState, type FocusEvent, type ReactNode } from 'react'
import { Button } from './Button'
import { DESIGN_COPY } from './copy'
import { StatusBar } from './StatusBar'

export const TOAST_DURATION_MS = 8_000

export interface ToastProps {
  title: string
  detail?: ReactNode
  action?: ReactNode
  onDismiss: () => void
}

const focusLeaves = (event: FocusEvent<HTMLDivElement>): boolean =>
  !(event.relatedTarget instanceof Node && event.currentTarget.contains(event.relatedTarget))

export const Toast = ({ title, detail, action, onDismiss }: ToastProps) => {
  const dismissRef = useRef(onDismiss)
  const [hovered, setHovered] = useState(false)
  const [focused, setFocused] = useState(false)
  const paused = hovered || focused

  useEffect(() => {
    dismissRef.current = onDismiss
  }, [onDismiss])

  useEffect(() => {
    if (paused) return
    const id = setTimeout(() => dismissRef.current(), TOAST_DURATION_MS)
    return () => clearTimeout(id)
  }, [paused])

  return (
    <div
      className="toast"
      onPointerEnter={() => setHovered(true)}
      onPointerLeave={() => setHovered(false)}
      onFocus={() => setFocused(true)}
      onBlur={(event) => setFocused(!focusLeaves(event))}
    >
      <StatusBar
        tone="info"
        title={title}
        {...(detail === undefined ? {} : { detail })}
        action={
          <>
            {action}
            <Button variant="ghost" onClick={onDismiss}>
              {DESIGN_COPY.dialogClose}
            </Button>
          </>
        }
      />
    </div>
  )
}
